module.exports = {
	"id": "GN",
	"name": "Guinea",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.062192,
			"12": 0.001352,
			"13": 0.002704,
			"14": 0.004056,
			"15": 0.002704,
			"16": 0.00676,
			"17": 0.02704,
			"18": null,
			"19": 0.001352,
			"20": 0.001352,
			"21": 0.009464,
			"22": null,
			"23": null,
			"24": 0.008112,
			"25": 0.0338,
			"26": 0.01352,
			"27": 0.001352,
			"28": 0.014872,
			"29": 0.01352,
			"30": 0.010816,
			"31": 0.021632,
			"32": 0.00676,
			"33": 0.045968,
			"34": null,
			"35": 0.001352,
			"36": 0.00676,
			"37": 0.05408,
			"38": 0.017576,
			"39": 0.00676,
			"40": 0.009464,
			"41": 0.018928,
			"42": 0.010816,
			"43": 0.275808,
			"44": 0.004056,
			"45": 0.083824,
			"46": 0.009464,
			"47": 0.050024,
			"48": 0.044616,
			"49": 0.208208,
			"50": 0.04732,
			"51": 0.22308,
			"52": 0.102752,
			"53": 2.917616,
			"54": 0.805792,
			"55": 0.016224,
			"56": 0.005408,
			"57": null
		},
		"firefox": {
			"2": 0.002704,
			"3": 0.035152,
			"4": 0.009464,
			"5": 0.005408,
			"6": 0.002704,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.008112,
			"11": 0.014872,
			"12": 0.004056,
			"13": 0.008112,
			"14": 0.00676,
			"15": 0.004056,
			"16": 0.008112,
			"17": 0.031096,
			"18": 0.002704,
			"19": 0.02028,
			"20": 0.012168,
			"21": 0.005408,
			"22": 0.02028,
			"23": 0.009464,
			"24": 0.025688,
			"25": 0.022984,
			"26": null,
			"27": 0.002704,
			"28": 0.018928,
			"29": 0.010816,
			"30": 0.045968,
			"31": 0.018928,
			"32": 0.02028,
			"33": 0.012168,
			"34": 0.02028,
			"35": 0.022984,
			"36": 0.009464,
			"37": 0.012168,
			"38": 0.036504,
			"39": 0.017576,
			"40": 0.014872,
			"41": 0.045968,
			"42": 0.021632,
			"43": 0.309608,
			"44": 0.052728,
			"45": 0.082472,
			"46": 0.050024,
			"47": 0.411008,
			"48": 0.544856,
			"49": 1.667016,
			"50": 0.051376,
			"51": 0.00676,
			"52": 0.002704,
			"3.5": 0.002704,
			"3.6": 0.032448
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.004056,
			"16": 0.001352,
			"17": 0.004056,
			"18": 0.004056,
			"19": 0.005408,
			"20": 0.002704,
			"21": null,
			"22": 0.001352,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.001352,
			"27": null,
			"28": 0.009464,
			"29": 0.106808,
			"30": 0.016224,
			"31": 0.008112,
			"32": 0.004056,
			"33": 0.0338,
			"34": 0.009464,
			"35": 0.012168,
			"36": 0.014872,
			"37": 0.366392,
			"38": 0.071656,
			"39": 0.024336,
			"40": 0.22984,
			"41": 0.029744,
			"42": 0.002704,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.005408,
			"12.1": 0.004056
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.036504,
			"7": 0.00676,
			"8": 0.028392,
			"9": 0.06084,
			"10": 0.118976,
			"3.1": null,
			"3.2": null,
			"5.1": 0.016224,
			"6.1": 0.002704,
			"7.1": 0.001352,
			"9.1": 0.205504
		},
		"ios_saf": {
			"8": 0,
			"10": 1.14096714738,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0307477443797,
			"8.1-8.4": 0.0568051548709,
			"9.0-9.2": 0.0270997069109,
			"9.3": 0.413444246461
		},
		"android": {
			"3": 0,
			"4": 0.125139018088,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.015642377261,
			"4.1": 0.451394315245,
			"4.2-4.3": 1.12848578811,
			"4.4": 2.58769612403,
			"4.4.3-4.4.4": 2.61004237726
		},
		"ie": {
			"6": null,
			"7": 0.00825816216216,
			"8": 0.141765117117,
			"9": 0.0289035675676,
			"10": 0.083957981982,
			"11": 0.494113369369,
			"5.5": null
		},
		"op_mob": {
			"0": 2.61993668363,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0727760189897
		},
		"edge": {
			"12": 0.08788,
			"13": 0.12168,
			"14": 0.100048
		},
		"ie_mob": {
			"10": 0.107430084507,
			"11": 0.437393915493
		},
		"bb": {
			"7": 0.01081,
			"10": null
		},
		"samsung": {
			"0": 1.547992
		},
		"and_uc": {
			"0": 3.735936
		},
		"op_mini": {
			"0": 35.2979512974
		},
		"and_chr": {
			"0": 33.031448
		},
		"and_ff": {
			"0": 0.458344
		}
	},
	"total": 97.4385681982
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GN.json
 ** module id = 534
 ** module chunks = 0
 **/